// cart-upsell-control.js
// Ensures upsell section stays hidden when disabled in settings
// Runs after cart updates to prevent reappearance

(function () {
  'use strict';

  function hideUpsellIfDisabled() {
    // Check theme setting
    const upsellEnabled = window.cartSettings && window.cartSettings.upsellEnabled === true;
    
    const upsellContainer = document.getElementById('upsell-container');
    if (!upsellContainer) return;

    // If upsell is disabled in settings, remove it entirely
    if (!upsellEnabled) {
      upsellContainer.remove();
    }
  }

  // Run immediately
  hideUpsellIfDisabled();

  // Run after cart updates
  document.addEventListener('pdm-cartUpdated', () => {
    setTimeout(hideUpsellIfDisabled, 100);
  });

  // Also listen for cart updates via pub/sub
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      setTimeout(hideUpsellIfDisabled, 100);
    });
  }

  // Watch for DOM changes in cart drawer
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    const observer = new MutationObserver(() => {
      hideUpsellIfDisabled();
    });
    
    observer.observe(cartDrawer, {
      childList: true,
      subtree: true,
    });
  }
})();
